import { createFileRoute } from "@tanstack/react-router";

import { JoinPage } from "@/features/auth/JoinPage";

/** Public: the page behind an invitation or password reset link. */
export const Route = createFileRoute("/join")({
  component: JoinPage,
});
